import { DateSelect } from "@/components/form/date-select";
import {
  makePickerField,
  type PickerFieldProps,
} from "@/fields/_internal/make-picker-field";

type DateFieldExtraProps = {
  /** IANA zone the picked calendar day is anchored to. */
  timeZone: string;
  placeholder?: string;
};

/** **Value is an ISO date-time string.** */
export type DateFieldProps = PickerFieldProps<string, DateFieldExtraProps>;

export const DateField = makePickerField<string, DateFieldExtraProps>({
  name: "DateField",
  control: DateSelect,
  controlProps: (props) => ({
    timeZone: props.timeZone,
    placeholder: props.placeholder,
  }),
});
